// src/contentfulClient.js
import { createClient } from "contentful";

// Initialize Contentful client
const client = createClient({
  space: "29uzy49sqz7s", // your Contentful space ID
  accessToken: "Nr-vo8HoloBZXVyKRbd2v_1jQY6HMOUNU06VHRTL85w", // replace with your delivery API key
  environment: "master", // default environment
});

// Function to fetch all blogs
export async function fetchBlogs() {
  try {
    const response = await client.getEntries({
      content_type: "blogs",
    });

    const assets = response.includes?.Asset || [];

    const blogs = response.items.map((item) => {
      const imageId = item.fields.blogImage?.sys?.id;
      const imageAsset = assets.find((asset) => asset.sys.id === imageId);

      // Safe access with fallback
      const imageUrl = imageAsset?.fields?.file?.url
        ? "https:" + imageAsset.fields.file.url
        : "https://via.placeholder.com/150";

      console.log("image", imageUrl);

      return {
        id: item.sys.id,
        name: item.fields.blogName || "Untitled Blog",
        description: item.fields.descriptions || "",
        image: imageUrl,
      };
    });

    return blogs;
  } catch (error) {
    console.error("Error fetching blogs:", error);
    return [];
  }
}

export default client;
